import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faBuilding } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';

const AddFloorModal = ({ show, onClose, onFloorAdded }) => {
  const [name, setName] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    onFloorAdded({ name });
    setName('');
    onClose();
  };

  return (
    <AdminFormModal
      show={show}
      onClose={onClose}
      title="Yeni Kat Ekle"
      subtitle="Masa yerleşimini bölecek yeni bir kat adı tanımlayın."
      icon={faPlus}
      footer={(
        <>
          <div className="admin-modal-footer-secondary">
            <Button variant="secondary" onClick={onClose} className="modal-cancel-btn">
              İptal
            </Button>
          </div>
          <div className="admin-modal-footer-primary">
            <Button variant="primary" onClick={handleSubmit} className="modal-save-btn">
              <FontAwesomeIcon icon={faPlus} />
              Kat Ekle
            </Button>
          </div>
        </>
      )}
    >
      <Form onSubmit={handleSubmit} className="admin-form-section">
        <div className="admin-form-block">
          <div className="admin-form-block-title">
            <FontAwesomeIcon icon={faBuilding} />
            Kat Bilgisi
          </div>
          <div className="admin-modal-field">
            <Form.Label>Kat Adı</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              className="form-input"
              placeholder="Örn: Zemin Kat, Teras, 1. Kat"
              required
            />
            <div className="admin-modal-helper">Kat adı masa seçici ve yerleşim ekranlarında görünür.</div>
          </div>
        </div>
      </Form>
    </AdminFormModal>
  );
};

export default AddFloorModal;
